import type { ReactNode } from "react";

const BlockField = ({ children }: { children: ReactNode }) => {
	return <>{children}</>;
};

export default BlockField;
